<script>
import {popup} from '@/helpers'
import copy from 'copy-to-clipboard'
import {successNotification} from '@/notifications'
import gateway from '@/gateway'
import gql from 'graphql-tag'

export default {
  data () {
    return {
      sendGdprToUser: null,
      sendInviteToUser: null,
      sendWelcomeToUser: null,
      sendForgotUser: null,
    }
  },
  methods: {
    async ghost (user, admin = false) {
      const {data} = await this.$http.post(`/users/${user.id}/ghost`)
      try {
        if (admin) {
          const url = `${window.location.protocol}//${window.location.hostname}:${window.location.port}/ghost?token=${data.data.accessToken}`
          copy(url)
          this.$notify(successNotification('Copied login URL to your clipboard.'))
        } else {
          popup(this, `${this.$portalUrl}sso?token=${data.data.accessToken}`)
        }
      } catch (e) {
        console.error(e)
      }
    },

    async sendForgot () {
      try {
        await gateway.post(`/crm/forgot-password`, {email: this.sendForgotUser.email})
        this.$notify(successNotification(`Sent a forgot password email to ${this.sendForgotUser.name}`))
      } catch (e) {
        console.error(e)
      }
    },

    sendForgotTo (user) {
      this.sendForgotUser = user
      this.$nextTick(() => this.$modal.show('confirm-send-forgot'))
    },

    async sendInvite () {
      try {
        const result = await this.$apollo.mutate({
          mutation: gql`mutation {
            sendInvitation (guid:"${this.sendInviteToUser.guid}") {
              email
            }
          }`,
        })

        this.$notify(successNotification(`Sent an invite email to ${this.sendInviteToUser.name}`))
      } catch (e) {
        console.error(e)
      }
    },

    sendInviteTo (user) {
      this.sendInviteToUser = user
      this.$nextTick(() => this.$modal.show('confirm-send-invite'))
    },

    async sendGdpr () {
      try {
        await this.$http.post(`/users/${this.sendGdprToUser.id}/gdpr`)
        this.$notify(successNotification(`Sent a GDPR email to ${this.sendGdprToUser.name}`))
      } catch (e) {
        console.error(e)
      }
    },

    sendGdprTo (user) {
      this.sendGdprToUser = user
      this.$nextTick(() => this.$modal.show('confirm-send-gdpr'))
    },

    sendWelcomeTo (user) {
      this.sendWelcomeToUser = user
      this.$nextTick(() => this.$modal.show('confirm-send-welcome'))
    },

    async sendWelcome () {
      try {
        await gateway.post(`/crm/users/${this.sendWelcomeToUser.id}/welcome`)
        this.$notify(successNotification(`Sent a welcome email to ${this.sendWelcomeToUser.name}`))
      } catch (e) {
        console.error(e)
      }
    },
  },
}
</script>
